import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ErrorsManager } from "@core/errors/errors.manager";
import { RolesAccount } from "@pages/auth/interfaces/auth.constant";
import { ICardThemesResponse } from "@pages/parents/modules/banking/cards/models/intefaces/api.responses";
import { catchError, map, Observable, tap, throwError } from "rxjs";
import { PROJECT_TAGS } from "src/app/configs/libraries/tracking-manager/constants/projects.constants";
import { TrackingManager } from "src/app/configs/libraries/tracking-manager/tracking-manager";
import { environment } from "src/environments/environment";
import { CARDS_API_EVENTS } from "./models/intefaces/cards.events.constants";
import { IUser } from "@pages/auth/interfaces/auth.interfaces";
import { errorContextType } from "@core/errors/models/types/errors.types";
import { CGetCardThemeApi } from "./models/constants/cards.error.constants";

@Injectable()
export class CardsApi {
  //#region [---- DEPENDENCIES ----]

  private readonly http: HttpClient = inject(HttpClient);
  private readonly trackingManager: TrackingManager = inject(TrackingManager);
  private readonly errorsManager: ErrorsManager = inject(ErrorsManager);

  //#endregion

  //#region [---- [PROPERTIES] ----]
  private BANKING_DOMAIN_URL: string = environment.APIS.BANKING_DOMAIN_URL;
  //#endregion

  public getCardsTheme(parentUser: IUser, ctx: errorContextType): Observable<string[]> {

    const url = `${this.BANKING_DOMAIN_URL}/card/v1/themes`;

    return this.http.get<ICardThemesResponse>(url).pipe(
      map((response) => response?.available_themes),
      tap((data) =>
        this.trackEvent(
          CARDS_API_EVENTS.API_SUCCESS_CARD_THEME_LIST_RETRIEVAL,
          data,
          parentUser
        )
      ),
      catchError((error: HttpErrorResponse) => {
        this.trackApiErrorEvent(
          CARDS_API_EVENTS.API_ERROR_CARD_THEME_LIST_RETRIEVAL,
          error,
          parentUser
        );
        this.errorsManager.manageErrors(error, ctx, {
            title: CGetCardThemeApi
        });
        return throwError(() => error);
      })
    );
  }

  private trackEvent(
    trackEventName: string,
    themeList: string[],
    parentUser: IUser
  ): void {
    this.trackingManager.trackEventV2(trackEventName, {
      project_tag: PROJECT_TAGS.ONBOARDING,
      Banking: {
        card: {
          theme: {
            list: themeList,
          },
        },
      },
      user: {
        id: parentUser?.id,
        role: RolesAccount.PARENT,
      },
    });
  }

  private trackApiErrorEvent(
    trackEventName: string,
    error: HttpErrorResponse,
    parentUser: IUser
  ): void {
    this.trackingManager.trackEventV2(
      trackEventName,
      {
        project_tag: PROJECT_TAGS.ONBOARDING,
        user: {
          id: parentUser?.id,
          role: RolesAccount.PARENT,
        },
      },
      error
    );
  }
}
